
import { defineComponent } from "vue";
import axios from "@/axios-instance";
import moment from "moment";
import { statusTagDefault } from "@/components/customers/ProfileDetailInfor.vue";

// Danh mục ngành (resolve TÊN ngành cho hồ sơ liên thông — arpros chỉ lưu MÃ) — cache dùng chung mọi lần mở drawer
let _majorsCache: any[] | null = null;
export async function loadMajorsOnce() {
  if (_majorsCache) return _majorsCache;
  try {
    const { data } = await axios.get("/major");
    _majorsCache = data || [];
  } catch (e) {
    _majorsCache = [];
  }
  return _majorsCache;
}

export default defineComponent({
  name: "ho-so-quick-drawer",
  data() {
    return {
      drawerVisible: false,
      adRegId: null as any, // id hồ sơ đang mở -> link "Mở trang chi tiết"
      drawerRow: null as any,
      drawerDetail: null as any,
      drawerLoading: false,
      arproMajorName: null as any,
      dataCustomer: null as any,
      statusTag: statusTagDefault as any,
      arrResource: {
        online: { label: "Trực tuyến", state: "success" },
        office: { label: "Trực tiếp", state: "danger" },
        offline: { label: "Trực tiếp", state: "danger" },
        postoffice: { label: "Bưu điện", state: "warning" },
        email: { label: "Email", state: "primary" },
      } as any,
    };
  },
  methods: {
    // Mở drawer theo id hồ sơ (adReg). Tự fetch chi tiết hồ sơ + thông tin ứng viên (cho header + Salesforce).
    async open(adRegId: string) {
      if (!adRegId) return;
      this.adRegId = adRegId;
      this.drawerRow = null;
      this.drawerDetail = null;
      this.dataCustomer = null;
      this.drawerLoading = true;
      this.drawerVisible = true;
      try {
        const { data } = await axios.get(`/admission/register/${adRegId}`);
        if (data?.adRegister?.updatedAt) {
          data.adRegister.updatedAtText = moment(data.adRegister.updatedAt).format("DD/MM/YYYY HH:mm");
        }
        this.drawerDetail = data;
        const reg = (data && data.adRegister) || {};
        const st = this.statusTag[reg.status] || {};
        this.drawerRow = {
          code: reg.profileCode,
          phase: reg.phase,
          method: this.methodLabelFull(),
          source: reg.source,
          date: reg.createdAt ? moment(reg.createdAt).format("DD/MM/YYYY") : "",
          status: { state: st.state, label: st.label, value: reg.status },
          isActive: reg.isActive,
          sentMail: reg.sentMail, //badge email phiếu ĐKXT (thay cột Email đã gỡ khỏi list)
          isAppraised: reg.isAppraised,
          majors: (data && data.adMajors) || [],
        };
        // Hồ sơ LIÊN THÔNG: resolve TÊN ngành từ mã (arpros.registeredmajor chỉ lưu mã)
        this.arproMajorName = null;
        if (reg._arpros && reg._arpros.registeredmajor) {
          const majors = await loadMajorsOnce();
          const m = (majors || []).find((x: any) => x.code == reg._arpros.registeredmajor);
          this.arproMajorName = m ? m.name : null;
        }
        // Thông tin ứng viên (header + Salesforce) — fetch theo idStudent của hồ sơ.
        if (reg.idStudent) {
          try {
            const res = await axios.get(`/admission/student/${reg.idStudent}`);
            this.dataCustomer = res.data;
          } catch (e) {
            // vẫn hiển thị phần hồ sơ dù không lấy được thông tin ứng viên
          }
        }
      } catch (e) {
        // im lặng
      }
      this.drawerLoading = false;
    },
    // Ngành của hồ sơ liên thông (adMajors rỗng) — đọc từ articulationprogram
    arproMajor() {
      const reg = ((this.drawerDetail && this.drawerDetail.adRegister) || {}) as any;
      const a = reg._arpros;
      if (!a || !a.registeredmajor) return null;
      return {
        name: this.arproMajorName || a.registeredmajor,
        code: a.registeredmajor,
        averageScore: a.admissionscores ? a.admissionscores.averageScore : null,
      };
    },
    methodLabel(m) {
      const names = { 1: "Học bạ", 2: "ĐGNL", 3: "Ưu tiên xét tuyển", 4: "Điểm thi THPT", 5: "Tương đương (SAT/ACT/TC01)", 6: "V-SAT", 9: "Liên thông" };
      return names[m] || (m != null && m !== "" ? "PT" + m : "—");
    },
    // Nhãn PT kèm biến thể Học bạ (admissiontype: THM/3YS/9CR; rỗng -> N/A)
    methodLabelFull() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || ({} as any);
      const base = this.methodLabel(reg.idAdMethod);
      if (reg.idAdMethod == 1) {
        const d = this.adDetail();
        const t = d && d.admissiontype ? String(d.admissiontype).trim() : "";
        return `${base} (${t || "N/A"})`;
      }
      return base;
    },
    adDetail() {
      const d = this.drawerDetail && this.drawerDetail.adDetails;
      if (!d) return null;
      return Array.isArray(d) ? d[0] || null : d;
    },
    scoreMethodLabel() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || ({} as any);
      const names = { 1: "Học bạ", 2: "ĐGNL", 3: "Ưu tiên xét tuyển", 4: "Điểm thi THPT", 5: "Tương đương (SAT/ACT/TC01)", 6: "V-SAT", 9: "Liên thông" };
      if (!names[reg.idAdMethod]) return null;
      return this.methodLabelFull();
    },
    // Học bạ không hợp lệ nếu biến thể != 9CR (chính sách UMT 2026)
    hocbaVariantInvalid() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || ({} as any);
      if (reg.idAdMethod != 1) return false;
      const d = this.adDetail();
      const t = d && d.admissiontype ? String(d.admissiontype).trim() : "";
      return t !== "9CR";
    },
    // Gom điểm theo đúng cách lưu của TỪNG phương thức → [{title, rows:[{label,value}], wide?}]
    scoreGroups() {
      const reg = (this.drawerDetail && this.drawerDetail.adRegister) || ({} as any);
      const m = reg.idAdMethod;
      const d = this.adDetail();
      const groups = [] as any[];
      const has = (v) => !(v === null || v === undefined || v === "");
      const num = (v) => (has(v) ? v : "—");
      const flat = (title, pairs, wide = false) => {
        if (!d) return;
        const rows = pairs.filter((p) => has(d[p[0]])).map((p) => ({ label: p[1], value: d[p[0]] }));
        if (rows.length) groups.push({ title, rows, wide: !!wide });
      };

      // PT9 liên thông: GPA từ _arpros
      if (m == 9) {
        const a = reg._arpros || {};
        const rows = [["gpa", "GPA"], ["gpafor", "Thang quy đổi"]]
          .filter((p) => has(a[p[0]])).map((p) => ({ label: p[1], value: a[p[0]] }));
        if (rows.length) groups.push({ title: "Điểm liên thông", rows, wide: false });
        return groups;
      }
      if (!d) return groups;

      if (m == 1) {
        const sps = [d.subjectpoint1, d.subjectpoint2, d.subjectpoint3];
        const has9CR = sps.some((s) => Array.isArray(s) && s.length);
        if (has9CR) {
          sps.forEach((arr, i) => {
            if (!Array.isArray(arr) || !arr.length) return;
            const picked = arr.some((it) => {
              const dt = (it && it.data) || {};
              return has(dt.point0) || has(dt.point1) || has(dt.point2);
            });
            if (!picked) return;
            const rows = arr.map((it) => {
              const dt = (it && it.data) || {};
              const subj = (it && (it.label || it.subject || it.type)) || "Môn";
              return { label: subj, value: `${num(dt.point0)} / ${num(dt.point1)} / ${num(dt.point2)}` };
            });
            if (rows.length) groups.push({ title: `Tổ hợp ưu tiên ${i + 1} — L10 / L11 / L12`, rows, wide: true });
          });
        } else {
          flat("Điểm TB môn lớp 12", [
            ["class12AverageMathScore", "Toán"], ["class12AverageLiteratureScore", "Ngữ văn"],
            ["class12AverageEnglishScore", "Tiếng Anh"], ["class12AveragePhysicsScore", "Vật lý"],
            ["class12AverageChemistryScore", "Hóa học"], ["class12AverageBiologyScore", "Sinh học"],
            ["class12AverageHistoryScore", "Lịch sử"], ["class12AverageGeographyScore", "Địa lý"],
            ["class12AverageFrenchScore", "Tiếng Pháp"], ["class12AverageCivicEducationScore", "GDCD"],
            ["class12AverageInformationTechnologyScore", "Tin học"], ["class12AverageEconomicsAndLawEducationScore", "GD KT&PL"],
            ["class12AverageArtScore", "Năng khiếu"],
          ]);
          flat("Điểm TB cả năm", [
            ["class10TotalScore", "Lớp 10"], ["class11TotalScore", "Lớp 11"],
            ["class12TotalScore", "Lớp 12"], ["class12Semester1Score", "Lớp 12 (HK1)"],
          ]);
        }
      } else if (m == 2) {
        flat("Điểm ĐGNL", [["totalScore", "Tổng điểm (thang 1200)"], ["nlqgScore", "Điểm quy đổi (thang 30)"]]);
      } else if (m == 3) {
        flat("Chứng chỉ", [["ieltsScore", "IELTS"], ["toeflScore", "TOEFL iBT"], ["toeicScore", "TOEIC"], ["satScore", "SAT"]]);
        const conds = [
          ["isCollegeDiploma", "Có bằng CĐ"], ["isInternationalCert", "Chứng chỉ quốc tế"],
          ["isNationalAward", "Giải quốc gia"], ["isGoodInHighschool", "HS giỏi THPT"],
          ["isAthleteCertOrPreMaster", "VĐV / Dự bị ĐH"],
        ].filter((p) => !!d[p[0]]).map((p) => ({ label: p[1], value: "✓" }));
        if (conds.length) groups.push({ title: "Diện đủ điều kiện", rows: conds, wide: false });
      } else if (m == 4) {
        flat("Điểm thi THPT", [
          ["mathScore", "Toán"], ["literatureScore", "Ngữ văn"], ["englishScore", "Tiếng Anh"],
          ["physicsScore", "Vật lý"], ["chemistryScore", "Hóa học"], ["biologyScore", "Sinh học"],
          ["historyScore", "Lịch sử"], ["geographyScore", "Địa lý"], ["frenchScore", "Tiếng Pháp"],
          ["civicEducationScore", "GDCD"], ["informationTechnologyScore", "Tin học"],
          ["economicsAndLawEducationScore", "GD KT&PL"], ["artScore", "Năng khiếu"],
        ]);
      } else if (m == 5) {
        if (has(d.formOfMethod)) groups.push({ title: "", rows: [{ label: "Tiêu chí", value: d.formOfMethod }], wide: false });
        flat("Điểm chuẩn hóa", [["sat", "SAT"], ["actScore", "ACT"], ["tc01AverageGrade12", "TB lớp 12 (TC01)"]]);
        flat("Điểm THPT (TC01)", [
          ["mathTHPT", "Toán"], ["literatureTHPT", "Ngữ văn"], ["englishTHPT", "Tiếng Anh"],
          ["physicsTHPT", "Vật lý"], ["chemistryTHPT", "Hóa học"], ["biologicalTHPT", "Sinh học"],
          ["historyTHPT", "Lịch sử"], ["geographyTHPT", "Địa lý"], ["frenchTHPT", "Tiếng Pháp"],
          ["civicEducationTHPT", "GDCD"], ["informationTechnologyTHPT", "Tin học"],
          ["economicsAndLawEducationTHPT", "GD KT&PL"], ["artTHPT", "Năng khiếu"],
        ]);
      } else if (m == 6) {
        flat("Điểm V-SAT", [
          ["mathScore", "Toán"], ["literatureScore", "Ngữ văn"], ["englishScore", "Tiếng Anh"],
          ["physicsScore", "Vật lý"], ["chemistryScore", "Hóa học"], ["biologyScore", "Sinh học"],
          ["historyScore", "Lịch sử"], ["geographyScore", "Địa lý"], ["normalizedScore", "Điểm quy đổi (thang 30)"],
        ]);
      } else if (d) {
        const rows = Object.keys(d)
          .filter((k) => /score|point|grade|sat|act|gpa/i.test(k) && typeof d[k] !== "object" && has(d[k]))
          .map((k) => ({ label: k, value: d[k] }));
        if (rows.length) groups.push({ title: "Điểm", rows, wide: false });
      }
      return groups;
    },
    sfMappedFields() {
      const c = (this.dataCustomer || {}) as any;
      const reg = ((this.drawerDetail && this.drawerDetail.adRegister) || {}) as any;
      const isVerified = this.drawerRow && this.drawerRow.status && this.drawerRow.status.value === "verified";
      const gender = (c.gender === true || c.gender === 1 || c.gender === "1") ? "Male"
        : (c.gender === false || c.gender === 0 || c.gender === "0") ? "Female" : null;
      const yearFrom = (v) => { if (!v) return null; const mm = String(v).match(/\d{4}/); return mm ? mm[0] : null; };
      const admYear = yearFrom(reg.createdAt) || yearFrom(c.createdAt) || yearFrom(this.drawerRow && this.drawerRow.date);
      let utm = c.utmobj;
      if (typeof utm === "string") { try { utm = JSON.parse(utm); } catch (e) { utm = {}; } }
      utm = utm || {};
      const arr = [
        { label: "Họ tên", sf: "LastName", value: c.fullName },
        { label: "SĐT", sf: "MobilePhone", value: c.phone },
        { label: "Email", sf: "Email", value: c.email },
        { label: "CCCD", sf: "CMND_CCCD__c", value: c.idCard },
        { label: "Loại", sf: "Enquiry_Type__c", value: "Student" },
        { label: "Giới tính", sf: "Gender__c", value: gender },
        { label: "Điểm ưu tiên", sf: "Priority_Score__c", value: (c.priorityScore || c.priorityScore === 0) ? c.priorityScore : null },
        { label: "Đối tượng ưu tiên", sf: "Priority_Category_i_t_ng_u_ti_n__c", value: c.priorityObject },
        { label: "Khu vực ưu tiên", sf: "Priority_Region_Khu_v_c_u_ti_n__c", value: c.priorityArea },
        { label: "Thường trú", sf: "Permanent_Address__c", value: c.prAddress },
        { label: "Mã hồ sơ", sf: "Application_ID__c", value: reg.profileCode },
        { label: "Ngày nộp", sf: "Admission_date__c", value: this.drawerRow && this.drawerRow.date },
        { label: "StageName", sf: "StageName", value: isVerified ? "Scholarship Interview" : null },
        { label: "Trường L12", sf: "Current_School__c", value: c["class12School.name"] || c.class12SchoolName },
        { label: "Tỉnh thường trú", sf: "New_Province__c", value: c.newPrProvinceName },
        { label: "UTM Source", sf: "utm_source__c", value: utm.utm_source },
        { label: "UTM Medium", sf: "utm_medium__c", value: utm.utm_medium },
        { label: "UTM Campaign", sf: "utm_campaign__c", value: utm.utm_campaign },
        { label: "Nguồn lead", sf: "LeadSource", value: "Admission Portal", fixed: true },
        { label: "Năm tuyển sinh", sf: "Admission_Year__c", value: admYear, fixed: true },
        { label: "Năm tốt nghiệp", sf: "Graduation_Year__c", value: admYear, fixed: true },
        { label: "Đã nộp HS", sf: "Application_Submitted__c", value: isVerified ? "true" : "(true khi verified)", fixed: true },
        { label: "Lưu trữ", sf: "Is_Archived__c", value: "false", fixed: true },
      ];
      return arr.filter((f) => f.value !== null && f.value !== undefined && f.value !== "");
    },
  },
});
